import React, {Component} from 'react';
import {getJsonCookieByKey, setJsonCookie} from '../../common/utilities/cookie';

const cookieName = 'WB_CookieNotification';

export class CookieNotification extends Component
{
    static displayName = 'CookieNotification';

    constructor(props) {
        super(props);

        this.state = {
            visible: true
        };
        this.cookieLoadComplete = false;
        this.hide = this.hide.bind(this);
        this.cookieManager = this.cookieManager.bind(this);
    }

    componentDidMount() {
        const { allowCookieAccess } = this.props;
        this.cookieManager(allowCookieAccess);
    }

    componentDidUpdate(prevProps) {
        const { allowCookieAccess } = this.props;
        // Because of appState rerender bug we need to ensure values are of correct type.
        if (typeof allowCookieAccess === 'boolean') {
            this.cookieManager(allowCookieAccess);
            if (!allowCookieAccess) {
                this.hide();
            }
        }
    }

    hide() {
        this.setState({visible: false});
    }

    cookieManager(allowCookieAccess) {
        if (allowCookieAccess && !this.cookieLoadComplete) {
            const cookie = getJsonCookieByKey(cookieName);
            if (cookie) {
                this.setState({visible: false});
            } else {
                setJsonCookie(cookieName, {
                    notificationDate: new Date()
                }, 10950);
            }
            this.cookieLoadComplete = true;   
        }
    }

    render() {
        if(this.state.visible) {
            return <div style={styles.container}>
                <div style={styles.textContainer}>
                    <span style={styles.text}>
                    We use technologies, such as cookies, to analyze your use (i.e., pages visited), to customize content, for our internal analytics purposes and for security and other purposes. By continuing to use this website, you agree to this usage. Please review our&nbsp;
                        <a href="/legal/privacy" style={{color: '#FFFFFF'}}>privacy policy</a>
                        &nbsp;for more details as well as for information on how to contact us to object to these activities. <a href='/legal/privacy#AC' style={{color: '#FFFFFF'}}>Ad Choices</a>
                    </span>
                </div>
                <div
                    style={styles.closeContainer}
                    onClick={() => {
                        this.hide();
                    }}
                >
                    <svg
                        style={styles.closeButton}
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 12.7 12.7"
                        enableBackground="new 0 0 12.7 12.7"
                        xmlSpace="preserve"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.3,11.2c-0.3,0.3-0.3,0.9,0,1.2l0,0c0.3,0.3,0.9,0.3,1.2,0l11-11
                                c0.3-0.3,0.3-0.9,0-1.2l0,0c-0.3-0.3-0.9-0.3-1.2,0L0.3,11.2L0.3,11.2z M0.3,11.2"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.5,11.2c0.3,0.3,0.3,0.9,0,1.2l0,0c-0.3,0.3-0.9,0.3-1.2,0l-11-11
                                c-0.3-0.3-0.3-0.9,0-1.2l0,0c0.3-0.3,0.9-0.3,1.2,0L12.5,11.2L12.5,11.2z M12.5,11.2"
                        />
                    </svg>
                </div>
            </div>;
        } else {
            return null;
        }
    }
}

const styles = {
    container: {
        minHeight: 30,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: 8,
        display: 'flex',
        alignItems: 'center',
        color: '#FFFFFF',
        fontSize: 14
    },
    textContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: 30
    },
    text: {
        color: '#FFFFFF',
        fontSize: 13,
        paddingLeft: 12,
        paddingRight: 12
    },
    link: {
        color: '#FFFFFF',
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    closeButton: {
        stroke: '#FFFFFF',
        fill: '#FFFFFF',
        width: 12,
        height: '100%'
    },
    closeContainer: {
        float: 'right',
        width: 12,
        height: 12,
        cursor: 'pointer'
    }
};
